<template>
  <div
    class="text-center my-4 w-100"
  >
    <VProgressCircular
      indeterminate
      color="blue-grey"
    />
  </div>
</template>
